import { render, staticRenderFns } from "./genAllocation.vue?vue&type=template&id=302f35b6&scoped=true&"
import script from "./genAllocation.vue?vue&type=script&lang=js&"
export * from "./genAllocation.vue?vue&type=script&lang=js&"
import style0 from "./genAllocation.vue?vue&type=style&index=0&id=302f35b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302f35b6",
  null
  
)

export default component.exports